import { createI18n } from 'vue-i18n'
//import axios from 'axios'
import ConfigAPI from '@/config/api'
import configAPI, { waitConfig } from '@/config/api'
import instance from '@/config/http'


const messages = {
  es: {},
  en: {},
}

export default async function cargarMensajes() {
  await waitConfig();  
  var url = ConfigAPI.baseURL + 'dictionary'
  let idiomaGuardado = localStorage.getItem('idiomaPreferido');
  if (!idiomaGuardado) {
    idiomaGuardado = 'es'
  }

  try {
    const response = await instance.post(url)
    const data = response.data

    // Iterar sobre la respuesta y llenar los objetos de mensajes
    data.forEach((entry) => {
      messages.es[entry.TAG] = entry.ESPANOL
      messages.en[entry.TAG] = entry.INGLES
    })
    const i18n = createI18n({
      legacy: false,
      locale: idiomaGuardado,
      fallbackLocale: 'en',
      messages,
    })
    return i18n
  } catch (error) {
    console.error('Error al cargar los mensajes de la API:', error)
    return createI18n({
      locale: idiomaGuardado,
      fallbackLocale: 'en',
      messages,
    })
  }
}
